import crud_actions from './crud_actions'
export const CLEAR_RESPONSES = 'clear_responses'

export const loadResponses = crud_actions.read('responses')

export const clearResponses = () => {
    return {
      type: CLEAR_RESPONSES,
    }
  }